
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/broadcaster",
      function () {
        return require("private-next-pages/broadcaster/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/broadcaster"])
      });
    }
  